import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddIcon from "@mui/icons-material/Add";
import { Form, Segment } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  inicio,
  hola,
  si,
  cancelar,
  permitir_notificaciones,
  TraducirEstado,
  cambio_de_estado_de_viaje,
  cargando_mapa,
  sin_servicio_en_tu_zona,
} from "../../../utils/traductor";
import {
  ENTORNO,
  HabilitarFireBase,
  HabilitarPooling,
} from "../../../utils/constantes";
import {
  getrole,
  getusuarioPerfil,
  getNombre,
  getPermitirNotificaciones,
  setPermitirNotificaciones,
  getPoolingActivado,
  setPoolingActivado,
  getViajeId,
  setGeolocalizacion,
  getGeolocalizacion,
  getemail,
} from "../../../utils/variablesLocales";
import "../../../scss/index.scss";
import { styled } from "@mui/material/styles";
import LogoutIcon from "@mui/icons-material/Logout";
import "../../../scss/index.scss";
import { EstadoViajeEnInicio } from "../../../componentes/NuevoViaje/EstadoViajeEnInicio";
import { getid } from "../../../utils/variablesLocales";
import { apiGeolocalizacion } from "../../../api/geolocalizacion";
import { apiViaje } from "../../../api/viaje";
import { apiUsuario } from "../../../api/usuario";
import { apiListaBlanca } from "../../../api/listaBlanca";
import Swal from "sweetalert2";
import { estiloColores } from "../../../estilos";
import { vas_a_cerrar_la_sesion } from "../../../utils/traductor";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";
import { Alert } from "@mui/material";

import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import animacionMuyPronto from "../../../imagenes/AnimacionesVarias/MuyPronto.json";
import animacionMuyPronto1 from "../../../imagenes/AnimacionesVarias/MuyPronto1.json";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const app = initializeApp(ENTORNO.firebaseConfig);
export const messaging = getMessaging(app);

const apigeolocalizacion = new apiGeolocalizacion();
const apiusuario = new apiUsuario();
const apiviaje = new apiViaje();
const apilistablanca = new apiListaBlanca();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: -30,
  left: 0,
  right: 0,
  margin: "0 auto",
});

export function Inicio(props) {
  const [EstaEnListaBlanca, setEstaEnListaBlanca] = useState(true);
  const [DatosOperacion, setDatosOperacion] = useState(null);
  const [BotonPago, setBotonPago] = useState(null);
  const [Saldo, setSaldo] = useState(null);
  const [EstadoId, setEstadoId] = useState("0");
  const [Estado, setEstado] = useState(null);
  const [ViajeId, setViajeId] = useState(null);
  const [Partida, setPartida] = useState(null);
  const [Destino, setDestino] = useState(null);
  const [VerEnGoogleMaps, setVerEnGoogleMaps] = useState(null);
  const [ChoferId, setChoferId] = useState(null);
  const [Pasajero, setPasajero] = useState(null);
  const [Kms, setKms] = useState(null);
  const [Min, setMin] = useState(null);
  const [Precio, setPrecio] = useState(null);
  const [PartidaLatitud, setPartidaLatitud] = useState(null);
  const [PartidaLongitud, setPartidaLongitud] = useState(null);
  const [Conductor, setConductor] = useState(null);
  const [Marca, setMarca] = useState(null);
  const [Modelo, setModelo] = useState(null);
  const [Color, setColor] = useState(null);
  const [Dominio, setDominio] = useState(null);
  const [PartidaLocalidad, setPartidaLocalidad] = useState(null);
  const [PartidaProvincia, setPartidaProvincia] = useState(null);
  const [
    VerEnGoogleMapsRutaBusquedaPasajero,
    setVerEnGoogleMapsRutaBusquedaPasajero,
  ] = useState(null);
  const [MinLlegadaABuscarPasajero, setMinLlegadaABuscarPasajero] =
    useState(null);
  const [DestinoLatitud, setDestinoLatitud] = useState(null);
  const [DestinoLongitud, setDestinoLongitud] = useState(null);

  const [Permisos, setPermisos] = useState("");
  const [TokenUsuario, setTokenUsuario] = useState("");
  const [Error, setError] = useState("");
  const [Mensaje, setMensaje] = useState("");

  const [openBackDrop, setopenBackDrop] = React.useState(false);
  const handleCloseBackDrop = () => {
    setopenBackDrop(false);
  };
  const handleOpen = () => {
    setopenBackDrop(true);
  };

  //////////////////////////////////////////////
  //DETECTAR PRIMER PLANO
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      actualizarEstado();
    } else {
    }
  });
  //////////////////////////////////////////////

  /////////////////////////
  //notificaciones
  const [open, setOpen] = React.useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [NotificacionUsuario, setNotificacionUsuario] = useState("");

  const permitirNotificaciones = async () => {
    try {
      obtenerTokenFirebase();
    } catch (error) {
      setError(error);
    }
  };

  const obtenerTokenFirebase = async () => {
    try {
      if (HabilitarFireBase) {
        //preguntar si quiere recibir notificaciones
        const permission = await Notification.requestPermission();
        setPermisos(permission);

        if (permission === "granted") {
          setPermitirNotificaciones(true);

          //obtener token
          let token = "";
          token = await getToken(messaging, {
            vapidKey: ENTORNO.vapidKey,
          }).catch((error) => setError(error));

          if (token) {
            setTokenUsuario(token);
            apiusuario.actualizarTokenNotificacion(token);
          } else {
            setTokenUsuario("");
          }
        } else {
          setPermitirNotificaciones(false);
        }
      }
    } catch (error) {
      setError(error);
    }
  };
  /////////////////////////

  useEffect(() => {
    (async () => {
      //verificar si usuario se encuentra en lista blanca,
      //caso contrario NO le permito crear nuevos viajes
      const resultadoListaBlanca = await apilistablanca.obtener(getemail());

      if (parseInt(resultadoListaBlanca.length) === 0) {
        setEstaEnListaBlanca(false);
      } else {
        setEstaEnListaBlanca(true);
      }

      ///////////////////////////////////////////////////

      if (HabilitarFireBase) {
        //activar escucha de notificaciones
        setError("Activando notificaciones desde useEffect");
        onMessage(messaging, (message) => {
          //actualizar token (esto lo hago porque iOS lo necesita)
          obtenerTokenFirebase();

          setNotificacionUsuario(message.notification.title);

          //cuando llega una notificacion, actualiza el estado
          actualizarEstado();

          //mostrar notificacion
          setMensaje(
            // TraducirEstado(cambio_de_estado_de_viaje) +
            //   ". " +
            message.notification.title
          );
          //mostrar mensaje de cambio de estado
          setOpen(true);
        });
      }
    })();
  }, []);

  /////////////////////////

  //pooling
  useEffect(() => {
    (async () => {
      if (HabilitarPooling) {
        //detectar sistema operativo
        const SistemaOperativo = navigator.userAgent.toLowerCase();
        console.log(SistemaOperativo);

        let esiPhone = SistemaOperativo.indexOf("iphone");
        let esMacos = SistemaOperativo.indexOf("macos");

        esiPhone = 1;
        esMacos = 1;
        ////////////////////////

        setInterval(async () => {
          // console.log(
          //   "Interval..., PoolingActivado: ",
          //   getPoolingActivado(),
          //   ", ViajeId: ",
          //   getViajeId()
          // );

          //es iOS
          if (esiPhone > -1 || esMacos > -1) {
            //existe viaje
            if (getViajeId() !== "" && getViajeId() !== null) {
              //pooling activado
              if (getPoolingActivado()) {
                // console.log(getViajeId());
                // console.log("Actualizando estado...");

                actualizarEstado();
              }
            }
          }
        }, 5000);
      }
    })();
  }, []);

  ///////////////////////////

  useEffect(() => {
    (async () => {
      actualizarEstado();
    })();
  }, []);

  const actualizarEstado = async () => {
    try {
      //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
      if (getrole() !== "Pasajero") {
        //pooling
        //setPoolingActivado(false);
        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      } else {
        //obtener ultimo viaje Activo: 1 (todos los Valorado=1, menos los FINALIZADO, CANCELADO)
        const UsuarioId = getid();

        const respuesta = await apiviaje.obtenerActivos(UsuarioId);

        if (respuesta.length > 0) {
          setEstadoId("0");
          setViajeId(respuesta[0]._id);
          setEstado(respuesta[0].Estado);
          setPartida(respuesta[0].PartidaDireccion);
          setDestino(respuesta[0].DestinoDireccion);
          setVerEnGoogleMaps(respuesta[0].VerEnGoogleMaps);
          setChoferId(respuesta[0].ChoferId);
          setPasajero(respuesta[0].Nombre + " " + respuesta[0].Apellido);
          setKms(respuesta[0].Kms);
          setMin(respuesta[0].Min);
          setPrecio(respuesta[0].PrecioBase);
          setPartidaLatitud(respuesta[0].PartidaLatitud);
          setPartidaLongitud(respuesta[0].PartidaLongitud);
          setConductor(respuesta[0].Chofer);
          setMarca(respuesta[0].Marca);
          setModelo(respuesta[0].Modelo);
          setColor(respuesta[0].Color);
          setDominio(respuesta[0].Dominio);
          setPartidaLocalidad(respuesta[0].Localidad);
          setPartidaProvincia(respuesta[0].Provincia);
          setVerEnGoogleMapsRutaBusquedaPasajero(
            respuesta[0].VerEnGoogleMapsRutaBusquedaPasajero
          );
          setMinLlegadaABuscarPasajero(respuesta[0].MinLlegadaABuscarPasajero);
          setDestinoLatitud(respuesta[0].DestinoLatitud);
          setDestinoLongitud(respuesta[0].DestinoLongitud);
          setSaldo(respuesta[0].Saldo);
          setBotonPago(respuesta[0].Mobbex_BotonDePago);
          setDatosOperacion(respuesta[0].Mobbex_BotonDePago_DatosOperacion);

          if (respuesta[0].Estado === "PENDIENTE") {
            setEstadoId("1");
          } else {
            if (respuesta[0].Estado === "CONDUCTOR ASIGNADO") {
              setEstadoId("3");
            } else {
              if (respuesta[0].Estado === "RUTA DE VIAJE ACTIVADA") {
                setEstadoId("4");
              } else {
                if (respuesta[0].Estado === "TRANSITO ACTIVADO") {
                  setEstadoId("5");
                } else {
                  if (respuesta[0].Estado === "FINALIZADO") {
                    setEstadoId("6");
                  }
                }
              }
            }
          }
        } else {
          setViajeId("");
          setEstado("");
          setEstadoId("0");
          setPartida("");
          setDestino("");
          setVerEnGoogleMaps("");
          setChoferId("");
          setPasajero("");
          setKms("");
          setMin("");
          setPrecio(0);
          setPartidaLatitud("");
          setPartidaLongitud("");
          setConductor("");
          setMarca("");
          setModelo("");
          setColor("");
          setDominio("");
          setPartidaLocalidad("");
          setPartidaProvincia("");
          setVerEnGoogleMapsRutaBusquedaPasajero("");
          setMinLlegadaABuscarPasajero("");
          setDestinoLatitud("");
          setDestinoLongitud("");
          setSaldo(0);
          setBotonPago("");
          setDatosOperacion("");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const navigate = useNavigate();

  const NuevoViaje = async () => {
    if (EstaEnListaBlanca === true) {
      setopenBackDrop(true);

      if (EstadoId === "0") {
        //pooling
        //setPoolingActivado(false);

        //calculo ip publica
        const ipPublica = require("react-public-ip");
        const ip = (await ipPublica.v4()) || "";

        ///////////////////////////////////////////////////////

        let Lat = "";
        let Lon = "";
        let gpsActivado = false;

        //calculo localidad y lat lon con ip publica
        const parametros = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };

        const respuesta = await fetch(
          ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ip),
          parametros
        );

        const respuestaJson = await respuesta.json();

        //regla de negocio para casos particulares: cordoba --> cordoba capital
        let Localidad = respuestaJson.city;
        if (respuestaJson.city === "Córdoba") {
          Localidad = "Córdoba Capital";
        }

        const Provincia = respuestaJson.region;

        const Pais =
          respuestaJson.country === "ES"
            ? "España"
            : respuestaJson.country === "AR"
            ? "Argentina"
            : "";

        Lat = respuestaJson.loc.split(",")[0];
        Lon = respuestaJson.loc.split(",")[1];
        gpsActivado = false;

        setGeolocalizacion(
          Localidad +
            "|" +
            Provincia +
            "|" +
            Pais +
            "|" +
            Lat +
            "|" +
            Lon +
            "|" +
            gpsActivado
        );

        ///////////////////////////////////////////////////////

        //calculo lat lon con GPS
        const onUbicacionConcedida = (ubicacion) => {
          Lat = ubicacion.coords.latitude;
          Lon = ubicacion.coords.longitude;

          gpsActivado = true;

          //calculo direccion postal
          CalcularDireccionPostal(
            Localidad,
            Provincia,
            Pais,
            Lat,
            Lon,
            gpsActivado
          );
        };

        const onErrorDeUbicacion = (err) => {
          gpsActivado = false;

          setGeolocalizacion(
            Localidad +
              "|" +
              Provincia +
              "|" +
              Pais +
              "|" +
              Lat +
              "|" +
              Lon +
              "|" +
              gpsActivado +
              "|"
          );
        };

        const opcionesDeSolicitud = {
          enableHighAccuracy: true, // Alta precisión
          maximumAge: 0, // No queremos caché
          timeout: 5000, // Esperar solo 5 segundos
        };

        // Solicitar
        navigator.geolocation.getCurrentPosition(
          onUbicacionConcedida,
          onErrorDeUbicacion,
          opcionesDeSolicitud
        );

        //aqui debo hacer backdrop de 3-5 segundos... Geolocalizando con una linda imagen o video...
        //para que tenga tiempo de cargar en memoria y calcular geo
        let Segundos = 0;
        let Intervalo = setInterval(async () => {
          Segundos = Segundos + 1;

          if (gpsActivado) {
            clearInterval(Intervalo);
            setopenBackDrop(false);
            navigate(ENTORNO.URL_APLICACION + "/Pasajero/NuevoViaje4");
          }

          if (Segundos === 2) {
            clearInterval(Intervalo);
            setopenBackDrop(false);
            navigate(ENTORNO.URL_APLICACION + "/Pasajero/NuevoViaje4");
          }
        }, 1000);
      } else {
      }
    }
  };

  const CalcularDireccionPostal = async (
    Localidad,
    Provincia,
    Pais,
    Lat,
    Lon,
    gpsActivado
  ) => {
    const resultado = await apigeolocalizacion.LatLonToDireccionPostal(
      Lat,
      Lon
    );

    let DireccionPostal = resultado.Direccion;

    setGeolocalizacion(
      Localidad +
        "|" +
        Provincia +
        "|" +
        Pais +
        "|" +
        Lat +
        "|" +
        Lon +
        "|" +
        gpsActivado +
        "|" +
        DireccionPostal
    );
  };

  const EditarPerfil = async () => {
    //pooling
    //setPoolingActivado(false);

    navigate(ENTORNO.URL_APLICACION + "/Pasajero/EditarPerfil");
  };

  const HistorialViajes = async () => {
    //pooling
    //setPoolingActivado(false);

    navigate(ENTORNO.URL_APLICACION + "/Pasajero/HistorialViajes");
  };

  const CerrarSesion = async () => {
    Swal.fire({
      title: vas_a_cerrar_la_sesion,
      text: "",
      // type: "warning",
      showCancelButton: true,
      confirmButtonText: si,
      confirmButtonColor: estiloColores.Azul,
      cancelButtonText: cancelar,
      cancelButtonColor: estiloColores.Gris,
    }).then((result) => {
      if (result.value) {
        //pooling
        //setPoolingActivado(false);

        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      }
    });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                <img
                  src={logoLocalPoint}
                  style={{ marginTop: "8px" }}
                  width="90"
                  alt="Logo"
                />
              </Typography>

              {EstadoId === "0" ? (
                <IconButton
                  size="large"
                  onClick={EditarPerfil}
                  edge="end"
                  color="inherit"
                >
                  <AccountCircleIcon />
                </IconButton>
              ) : (
                <div></div>
              )}
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 0 }}>
              <Segment style={estiloSegmento.Pasajero}>
                <Form>
                  <div style={{ textAlign: "center" }}>
                    <h2>
                      {hola} {getNombre()}
                    </h2>

                    <Button onClick={permitirNotificaciones}>
                      {permitir_notificaciones}
                    </Button>
                  </div>

                  {EstaEnListaBlanca === false ? (
                    <div></div>
                  ) : (
                    <EstadoViajeEnInicio
                      EstadoId={EstadoId}
                      Perfil={getusuarioPerfil()}
                      ViajeId={ViajeId}
                      Partida={Partida}
                      Destino={Destino}
                      VerEnGoogleMaps={VerEnGoogleMaps}
                      ChoferId={ChoferId}
                      Pasajero={Pasajero}
                      Kms={Kms}
                      Min={Min}
                      Precio={Precio}
                      PartidaLatitud={PartidaLatitud}
                      PartidaLongitud={PartidaLongitud}
                      Conductor={Conductor}
                      Marca={Marca}
                      Modelo={Modelo}
                      Color={Color}
                      Dominio={Dominio}
                      PartidaLocalidad={PartidaLocalidad}
                      PartidaProvincia={PartidaProvincia}
                      VerEnGoogleMapsRutaBusquedaPasajero={
                        VerEnGoogleMapsRutaBusquedaPasajero
                      }
                      MinLlegadaABuscarPasajero0={MinLlegadaABuscarPasajero}
                      DestinoLatitud={DestinoLatitud}
                      DestinoLongitud={DestinoLongitud}
                      Saldo={Saldo}
                      BotonPago={BotonPago}
                      DatosOperacion={DatosOperacion}
                    ></EstadoViajeEnInicio>
                  )}

                  {EstaEnListaBlanca === false ? (
                    <div style={{ textAlign: "center" }}>
                      <Player
                        src={animacionMuyPronto}
                        className="player"
                        loop
                        autoplay
                        style={{ height: 150 }}
                      />
                      <Alert severity="error" style={{ textAlign: "justify" }}>
                        {sin_servicio_en_tu_zona}
                      </Alert>
                      <Player
                        src={animacionMuyPronto1}
                        className="player"
                        loop
                        autoplay
                        style={{ height: 200 }}
                      />
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Form>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
          <AppBar
            position="fixed"
            color="primary"
            sx={{ top: "auto", bottom: 0 }}
          >
            <Toolbar style={{ background: "white", color: "#153B5E" }}>
              {EstadoId === "0" ? (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={(e) => HistorialViajes(e)}
                >
                  <CalendarMonthIcon />
                </IconButton>
              ) : (
                <div></div>
              )}
              {EstadoId === "0" && EstaEnListaBlanca === true ? (
                <StyledFab
                  style={{ background: "#DC030E", color: "white" }}
                  onClick={(e) => NuevoViaje(e)}
                  aria-label="add"
                >
                  <AddIcon />
                </StyledFab>
              ) : (
                <StyledFab
                  style={{ background: "#DEE3E9", color: "white" }}
                  onClick={(e) => NuevoViaje(e)}
                  aria-label="add"
                >
                  <AddIcon />
                </StyledFab>
              )}
              <Box sx={{ flexGrow: 1 }} />
              <IconButton color="inherit" onClick={(e) => CerrarSesion(e)}>
                <LogoutIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        </React.Fragment>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          icon={<InfoOutlinedIcon fontSize="inherit" />}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {Mensaje}
        </Alert>
      </Snackbar>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
        onClick={handleCloseBackDrop}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
